<template>
  <div :class="['form-input', { 'input-small': smallInput, 'checkbox': isCheckbox }]">
    <slot name="label"></slot>
    <label v-if="!customLabel" :for="labelFor" :class="{ 'error': hasError }">
      {{ labelText }}{{ required ? '*' : '' }}
    </label>
    <slot></slot>
    <span v-if="hasError" class="error-msg">{{ errorText }}</span>
  </div>
</template>
<script>
export default {
  props: {
    labelFor: {
      type: String,
      required: true,
    },
    labelText: {
      type: String,
      required: true,
    },
    showError: {
      type: Boolean,
      default: false,
    },
    errorText: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    smallInput: {
      type: Boolean,
      default: false,
    },
    isCheckbox: {
      type: Boolean,
      default: false,
    },
    customLabel: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['change'],
  computed: {
    hasError() {
      return this.showError && this.errorText.length > 0;
    }
  },
}
</script>
<style scoped>
label.error {
  color: red;
}

input.error,
select.error {
  border: 1px solid red !important;
}

input.error:focus,
select.error {
  outline-color: red;
}

.form-input {
  position: relative;
  font: var(--bold-16-20);
  line-height: 28px;
  margin-bottom: 15px;
}

label.error {
  color: red;
}

.checkbox {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  gap: 8px;
  font: var(--medium-16);
}

.radio {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
}

.error-msg {
  color: red;
  font: var(--bold-10);
  font-style: italic;
}

</style>